'use strict';

var Draw = require('./draw/Draw');

function LayerUtils ($injector) {
  this.Draw = $injector.invoke(Draw);
  this.Edit = require('./edit');
  this.Transform = require('./transform/Transform');
}

LayerUtils.$inject = ['$injector'];
module.exports = LayerUtils;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/LayerUtil.js